import React from 'react';
import { IconButton } from 'material-ui';
import R from 'ramda';

export const readAccessIcon = <IconButton tooltip="Read Access" iconClassName="tc-icon-remove_red_eye" iconStyle={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px', padding: 0, marginTop: '5px' }} style={{ width: '50%' }}/>;
export const writeAccessIcon = <IconButton tooltip="Write Access" iconClassName="tc-icon-mode_edit" iconStyle={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px', padding: 0, marginTop: '5px' }} style={{ width: '50%' }}/>;
export const noAccessIcon = <IconButton tooltip="No Access" iconClassName="tc-icon-block" iconStyle={{ color: 'rgba(255, 64, 129, 0.8)', fontSize: '14px', padding: 0, marginTop: '5px' }}/>;

export const getAccessIcons = R.cond([
  [R.contains('write'), R.always(
    <span style={{ width: '100%' }}>
      {readAccessIcon}
      {writeAccessIcon}
    </span>)],
  [R.contains('read'), R.always(<span>{readAccessIcon}</span>)],
  [R.T, R.always(<span>{noAccessIcon}</span>)],
]);

export const getCreateLocIcon = R.ifElse(
  R.contains('createLocation'),
    R.always(writeAccessIcon),
  R.always(noAccessIcon)
);



// WEBPACK FOOTER //
// ./src/app/components/settings/accessIcons.js